import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getInterests = async () => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getInterestsApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  return data;
};

export const updateInterests = async (interestList) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.addInterestApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      user_interest_id: interestList,
    },
  });

  return data;
};

export const updateExpertise = async (expertiseList) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.addExpertiseApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      user_expertise_id: expertiseList,
    },
  });

  return data;
};

const ProfileService = { getInterests, updateInterests, updateExpertise };
export default ProfileService;
